import cn from "classnames"
import { forwardRef } from "react"

import { getProfileHref } from "../../utils/getProfileHref"

import styles from "./styles.module.scss"

import { PsychologistAvatar } from "components/PsychologistAvatar/PsychologistAvatar"
import { Psychologist } from "utils/interfaces"

interface Props {
    psyProfiles: Psychologist[]
    activePsy: Psychologist
    searchParams: URLSearchParams | Map<string, string | null>
}

export const AvatarList = forwardRef<HTMLDivElement, Props>(
    ({ psyProfiles, activePsy, searchParams }, ref) => {
        return (
            <div ref={ref} className={styles.list}>
                {psyProfiles.map((psy, index) => {
                    return (
                        <div className={styles.item} key={index}>
                            <a
                                href={getProfileHref(psy.profile_url, searchParams)}
                                className={cn(styles.link, {
                                    [styles.selected]: activePsy.hash_id === psy.hash_id,
                                })}
                            >
                                <PsychologistAvatar
                                    psy={psy}
                                    className={styles.avatarImgWrapper}
                                    imgClassName={styles.avatarImg}
                                />
                            </a>
                        </div>
                    )
                })}
            </div>
        )
    }
)

AvatarList.displayName = "AvatarList"
